import styled from "styled-components";
import ArrowDown from '../../../assets/icons/icon-arrow-down.svg'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    padding: 1.5rem;
    padding-top: 3rem;
    max-height: 20.625rem;
    min-height: 20.625rem;
    max-width: 20.625rem;

    display: flex;
    
    border-radius: 1rem;
    justify-content: center;
    background-color: #F8F8F9;

    @media (max-width: 1320px) {
        max-width: 100%;
        padding-top: 1rem;
    }

    @media (max-width: 768px) {
        max-width: 100%;

        
        justify-content: center;
    }

    @media (max-width: 400px) {
        padding-top: 2rem;
        min-height: fit-content;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const ProfileCircle = styled.div`
    width: auto;
    height: auto;
    position: relative;
    
    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const InitialsCircle = styled.div`
    width: 2rem;
    height: 2rem;
    left: calc(50% - 6rem);
    top: 0.9rem;
    position: absolute;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    color: white;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 50%;
    background-color: #21262F;
`;

export const Profile = styled.div`
    width: 13.3125rem;
    height: auto;
    padding: 0.5rem 0.5rem 0.5rem 0.25rem;
    
    gap: 0.5rem;
    display: flex;
    cursor: pointer;
    margin-top: 0.4rem;
    align-items: center;
    
    border-radius: 10rem;
    background-repeat: no-repeat;
    background-color: #F3F3F5;
    background-image: url("${ArrowDown}");
    background-position: right 1.188rem center;



    > img {
        width: 2rem;
        height: 2rem;
        border-radius: 10rem;
    }

    > p {
        color: #21262F;
        cursor: pointer;
        font-weight: 800;
        font-size: 0.5625rem;
        letter-spacing: 0.1rem;
        line-height: 0.84375rem;
        font-family: "Lato", Sans-serif;
    }

    select {
        width: 8rem;
        height: 2rem;
        
        position: relative;
        margin-left: calc(50% - 3.8rem);

        text-align: center;
        border: 0;
        cursor: pointer;
        color: #21262F;
        font-weight: 800;
        appearance: none;
        font-size: 0.5625rem;
        letter-spacing: 0.1rem;
        text-transform: uppercase;
       
        font-family: 'Lato', sans-serif;
        background-color: transparent;

        /* Novos ajustes para o nome muito longo */
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const ButtonProfile = styled.button`
    all: unset;
    display: flex;
    cursor: pointer;
    align-items: center;
`;

export const CirclesContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    
    @media (max-width: 400px) {
        flex-direction: column;
        justify-content: center;
    }
`;

export const CircleData = styled.div`
    flex-direction: column;

    >p{
        text-align: center;
    }
    
    @media (max-width: 400px) {
        display: flex;
        align-items: center;
    }
`;

export const CircleTRT = styled.div`
    flex-direction: column;

    >p{
        text-align: center;
    }
    
    @media (max-width: 400px) {
        display: flex;
        align-items: center;
    }
`;